module.exports = __webpack_public_path__ + "static/img/img-list-none.48b373e5.png";